/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forPaymentIntegration } from "./constants";

const CancelToken = axios.CancelToken;

// get payment
export let cancelGetPaymnetIntegartionApi;
export async function getPaymnetIntegartion(token, account_id) {
    if (token && account_id) {
        const payments = await axios.get(
            apiUrl_forPaymentIntegration +
                "check/paymentIntegration/" +
                account_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetPaymnetIntegartionApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}
// add payment
export let cancelAddPaymentIntegrationApi;
export async function addPaymentIntegration(token, data) {
    if ((token, data)) {
        const payments = await axios.post(
            apiUrl_forPaymentIntegration + "check/paymentIntegration",
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddPaymentIntegrationApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelEditPaymentIntegrationApi;
export async function editPaymentINtegration(token, account_id = "1") {
    if ((token, account_id)) {
        const payments = await axios.post(
            apiUrl_forPaymentIntegration +
                "check/paymentIntegration?account_id=" +
                account_id,
            account_id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditPaymentIntegrationApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}
